import palette from '../../theme/palette';
import { Graph } from '../../components/Graph';
import { withLoadingAndOverlay } from '../../hoc';

function VersionScoreDistribution({ data }) {
  const labels = data.map((item) => item.version);
  const datasetKeys = ['less than 25%', 'between 25% to 75%', 'greater than 75%'];

  const datasets = datasetKeys.map((key, index) => {
    const backgroundColors = [palette.error.main, palette.warning.main, palette.success.main]; // red, yellow, green
    return {
      label: `Accounts ${key}`,
      data: data.map((item) => item[key] || 0),
      backgroundColor: backgroundColors[index],
      barThickness: 15,
      borderWidth: 0,
    };
  });

  const options = {
    // indexAxis: 'y', // Makes the bars horizontal
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Version KPI Score Distribution',
        align: 'center',
        position: 'top',
        font: {
          size: 14,
        },
      },
      legend: {
        position: 'bottom',
      },
      tooltip: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
        callbacks: {
          label(context) {
            const label = context.dataset.label || '';
            const value = context.raw;
            return `${label}: ${value}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true, // Stack bars horizontally
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: 'Versions',
        },
      },
      y: {
        ticks: { precision: 0 },
        suggestedMax: 5,
        beginAtZero: true,
        stacked: true, // Ensure categories on Y are stacked
        title: {
          display: true,
          text: 'Number Of Accounts',
        },
      },
    },
  };

  return (
    <Graph
      type="bar"
      labels={labels}
      datasets={datasets}
      options={options}
    />
  );
}

export default withLoadingAndOverlay(VersionScoreDistribution);
